import http from '../../plugins/axios';

export default {

    getCategoryList(data) {
        return http.get({
            url: '/admin/product/category/list',
            data
        })
    },

    updateShowedStatus({categoryId, showed}) {
        return http.post({
            url: `/admin/product/category/updateShowed`,
            data: {
                categoryId,
                showed
            },
            dataType: 'form'
        });
    },

    deleteCategory({categoryId}) {
        return http.post({
            url: `/admin/product/category/delete`,
            data: {
                categoryId
            },
            dataType: 'form'
        });
    },

    createOrUpdateProductCategory({categoryId, zhName, enName, krName, viName, sort, showed}) {
        return http.post({
            url: `/admin/product/category/create`,
            data: {
                categoryId,
                zhName,
                enName,
                krName,
                viName,
                sort,
                showed,
            },
            dataType: 'form'
        });
    },

    getSelectionList(data) {
        return http.get({
            url: '/admin/product/selection/list',
            data
        })
    },

    updateSelectionShowedStatus({selectionId, showed}) {
        return http.post({
            url: `/admin/product/selection/updateShowed`,
            data: {
                selectionId,
                showed
            },
            dataType: 'form'
        });
    },

    deleteSelection({selectionId}) {
        return http.post({
            url: `/admin/product/selection/delete`,
            data: {
                selectionId
            },
            dataType: 'form'
        });
    },

    createOrUpdateProductSelection(data) {
        return http.post({
            url: `/admin/product/selection/create`,
            data: data,
        });
    },

    getSelectionOne(data) {
        return http.get({
            url: '/admin/product/selection/one',
            data,
        })
    },

    getRecommendList(data) {
        return http.get({
            url: '/admin/product/recommend/list',
            data
        })
    },

    updateRecommendHomePage({recommendId, homePage}) {
        return http.post({
            url: `/admin/product/recommend/updateShowed`,
            data: {
                recommendId,
                homePage
            },
            dataType: 'form'
        });
    },

    deleteRecommend({recommendId}) {
        return http.post({
            url: `/admin/product/recommend/delete`,
            data: {
                recommendId
            },
            dataType: 'form'
        });
    },

    createOrUpdateProductRecommed({recommendId, productType, productConfigId, productParam, sort, homePage}) {
        return http.post({
            url: `/admin/product/recommend/create`,
            data: {
                recommendId,
                productType,
                productConfigId,
                productParam,
                sort,
                homePage,
            },
            dataType: 'form'
        });
    },

    getAllFinancial() {
        return http.get({
            url: `/admin/product/financial/financialList`,
        });
    },

    getNonstopList() {
        return http.get({
            url: '/admin/product/financial/nonstop/list'
        })
    },

    updateFinancilNonstop({productType, showed, sort}) {
        return http.post({
            url: `/admin/product/financial/nonstop/update`,
            data: {
                productType,
                showed,
                sort,
            },
            dataType: 'form'
        });
    },

    getMiningExplain() {
        return http.get({
            url: '/admin/product/financial/mining/explain'
        })
    },

    updateMiningExplain({zh,en,kr,vi}) {
        return http.post({
            url: `/admin/product/financial/mining/update`,
            data: {
                zh,
                en,
                kr,
                vi,
            },
            dataType: 'form'
        });
    },
    
    refreshFinancialProductCache() {
        return http.get({
            url: `/admin/product//financial/refresh`,
            dataType: 'form'
        });
    },
}
